import { useMemo } from 'react'
import {
  Deposit,
  Condition,
  DepositPayable,
  FormCondition,
} from '@urbanx/agx.campaigns.client'

export default function useDefaultDepositPayableValue(
  formCondition?: FormCondition | Deposit
): DepositPayable {
  return useMemo(() => {
    // If depositPayable is explicitly set, use it first. Some saved conditions
    // can retain daysFromDate after being changed back to "on...".
    if (formCondition?.depositPayable) {
      return formCondition.depositPayable as unknown as DepositPayable
    }

    // If OnSpecificDate condition, OnDate condition (deposit), or referenceDate is set, it's "on"
    if (
      formCondition?.condition === Condition.OnSpecificDate ||
      formCondition?.condition === Condition.OnDate ||
      formCondition?.referenceDate
    ) {
      return DepositPayable.On
    }

    // If daysFromDate is set or AsPerContract condition, it's "N days from"
    if (
      formCondition?.daysFromDate !== undefined ||
      formCondition?.condition === Condition.AsPerContract
    ) {
      return DepositPayable.NDaysFrom
    }

    return DepositPayable.NDaysFrom
  }, [formCondition])
}
